<div
  [ngClass]="{
    'main-grid': true,
    'main-grid-menu': true,
    'main-grid-high-contrast': visualAccessibilityOn,
    'main-grid-template':true,
    'main-grid-template-high-contrast': visualAccessibilityOn,
    'text-color-blind': colorblindModeOn
  }"
  >

  <div *ngIf="!visualAccessibilityOn" class='grid-target' [ngStyle]="{'grid-area':'logo'}">
    <img
      class="main-logo"
      [attr.aria-label]="'kielen_paalla_logo' | ariaTranslate: languageService.uiLanguage"
      [ngClass]="{ 'main-logo-high-contrast': visualAccessibilityOn }"
      src="{{'./assets/images/logos/Kielen_paalla_' + languageService.uiLanguage + '.svg'}}">
  </div>

  <!-- Language selection -->
  <div class='grid-target' [ngStyle]="{'grid-area':'langSel'}">

    <p [ngStyle]="{'margin': '10px 0 10px 0' }">{{(keyboardControlOn ? '[L] ' : '') + ('choose_language'|translate)}}</p>

    <div class='select-background' id='language-select-background'>
      <button mat-button *ngFor='let language of languageChoices'
              [ngClass]="{
                'choice-button': true,
                'choice-button-regular': !colorblindModeOn,
                'choice-button-color-blind': colorblindModeOn,
                'highLightedChoice': language == languageService.learnLanguage && !colorblindModeOn,
                'highLightedChoice-color-blind': language == languageService.learnLanguage && colorblindModeOn
              }"
              (click)=chooseLanguage(language)
              [disableRipple]="true"
      >
        <img
          [ngClass]="{
            'round-button-lang': language != 'en',
            'round-button-en': language == 'en'
          }"
          src="{{'./assets/images/UI/flag_' + language + '.svg'}}">
      </button>
    </div>


    <p [ngStyle]="{'margin': '5px 0 0 0' }">{{languageText|translate}}</p>

  </div>

  <!-- Difficulty selection -->
  <div class='grid-target' [ngStyle]="{'grid-area':'diffSel', 'justify-content':'flex-start'}" [attr.aria-label]="'vaikeusaste' | ariaTranslate: languageService.uiLanguage">

    <p [ngStyle]="{'margin': '10px 0 10px 0' }">{{(keyboardControlOn ? '[D] ' : '') + ('choose_difficuly'|translate)}}</p>

    <div class='select-background' id='difficulty-select-background' >
      <button mat-button *ngFor='let difficulty of difficultyChoices'
              [ngClass]="{
                'choice-button': true,
                'choice-button-regular': !colorblindModeOn,
                'choice-button-color-blind': colorblindModeOn,
                'highLightedChoice': difficulty.diff == gameService.difficulty && !colorblindModeOn,
                'highLightedChoice-color-blind': difficulty.diff == gameService.difficulty && colorblindModeOn
              }"
              (click)=chooseDifficulty(difficulty.diff)
              [disableRipple]="true"
      >
        <img
            [ngClass]="{
              'round-button-diff': true
            }"
            src="{{difficulty.img}}">
      </button>
    </div>


    <p [ngStyle]="{'margin': '10px 0 5px 0' }">{{difficultyText|translate}}</p>
    <p [ngClass]="{'description': true, 'description-high-contrast': visualAccessibilityOn}">{{difficultyDescription|translate}}</p>

  </div>

  <!-- Start button -->
  <div class='grid-target' [ngStyle]="{'grid-area':'button'}">
    <button
      mat-button
      (click)='ToGame()'
      class='start-button'
      [ngClass]="{
        'text-color-blind': colorblindModeOn,
        'start-button-high-contrast': visualAccessibilityOn
      }"
    >{{(keyboardControlOn ? '[ENTER] ' : '') + ('start_game'|translate)}}</button>
  </div>

</div>
